import Styles from './FacebookPost.module.scss'
import { Skin } from '../Skin'
import { SkinProps } from '../Types'

const FacebookPost = ({ children, maxCharacterCount }: SkinProps) => {
  return (
    <Skin.Root className={Styles.facebookPost} data-testid="facebook-frame-skin">
      <Skin.CaptionAbove lines={6} maxCharacterCount={maxCharacterCount} />
      {children}
    </Skin.Root>
  )
}

export { FacebookPost }
